import {
  FontColorEnum,
  FontSizeEnum,
  IconButton,
  IconButtonColorEnum,
  IconButtonSizeEnum,
  IconSizeEnum,
  PlusIcon,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

type ClipTooltipProps = {
  handleClick: () => void;
  disabled?: boolean;
};
export function ClipTooltip({ handleClick, disabled }: ClipTooltipProps) {
  const { t } = useTranslation();
  return (
    <Tooltip
      help={
        <>
          <Typography fontSize={FontSizeEnum.Xs} color={FontColorEnum.Neutral}>
            {t('Pasos')}:
            <br />
            <br />
          </Typography>
          <ol>
            <li>
              <Typography fontSize={FontSizeEnum.Xs} color={FontColorEnum.Neutral}>
                {t('Crea una marca de tiempo (Inicio y Fin)')}
              </Typography>
            </li>
            <li>
              <Typography fontSize={FontSizeEnum.Xs} color={FontColorEnum.Neutral}>
                {t('Pulsar sobre el botón más')}
              </Typography>
            </li>
            <li>
              <Typography fontSize={FontSizeEnum.Xs} color={FontColorEnum.Neutral}>
                {t('Dibuja el cuadro delimitador en el player')}
              </Typography>
            </li>
            <li>
              <Typography fontSize={FontSizeEnum.Xs} color={FontColorEnum.Neutral}>
                {t('Selecciona o crea uno nuevo en el desplegable')}
              </Typography>
            </li>
          </ol>
        </>
      }
    >
      <IconButton
        color={IconButtonColorEnum.DEFAULT_REVERSE}
        size={IconButtonSizeEnum.SM}
        disabled={disabled}
      >
        <PlusIcon onClick={handleClick} size={IconSizeEnum.SM} disabled={disabled} />
      </IconButton>
    </Tooltip>
  );
}
